var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.5V20C4 20.5305 4.21071 21.0392 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0392 20 20.5305 20 20V16.5M3 14V13C3 12.4696 3.21071 11.9609 3.58579 11.5858C3.96086 11.2107 4.46957 11 5 11H19C19.5304 11 20.0391 11.2107 20.4142 11.5858C20.7893 11.9609 21 12.4696 21 13V14M12 8.00003V11M12 8.00003C13.262 8.00003 14 7.03203 14 5.37503C14 3.71803 12 2.00003 12 2.00003C12 2.00003 10 3.71803 10 5.37503C10 7.03203 10.738 8.00003 12 8.00003Z",
    stroke: "#5C5CAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C3 14.7957 3.31607 15.5587 3.87868 16.1214C4.44129 16.684 5.20435 17 6 17C6.79565 17 7.55871 16.684 8.12132 16.1214C8.68393 15.5587 9 14.7957 9 14C9 14.7957 9.31607 15.5587 9.87868 16.1214C10.4413 16.684 11.2044 17 12 17C12.7956 17 13.5587 16.684 14.1213 16.1214C14.6839 15.5587 15 14.7957 15 14C15 14.7957 15.3161 15.5587 15.8787 16.1214C16.4413 16.684 17.2044 17 18 17C18.7956 17 19.5587 16.684 20.1213 16.1214C20.6839 15.5587 21 14.7957 21 14",
    stroke: "#5C5CAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.0631157e15f19e4f9f6f717a649a311b.svg";
export { ForwardRef as ReactComponent };